/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEmploymentsForPersonRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GetEmploymentsForPersonResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const getEmploymentsForPerson = (request: GetEmploymentsForPersonRequest, options?: CashRequestOptions) => post<GetEmploymentsForPersonRequest, GetEmploymentsForPersonResponse>("/2.0/cash/get-employments-for-person", request, {...options, rejectOnError: true })